import type { NotificationEntityType } from '~/apis/notificationsApi';
import { ROUTES } from '~/utils/constants';

export function getNotificationPath(
  entityType: NotificationEntityType | string,
  entityId: string
): string | null {
  const id = entityId?.trim();
  if (!id) return null;

  switch (entityType) {
    case 'cn01_form':
      return `${ROUTES.CN01_DETAIL}/${id}`;
    case 'cn03_form':
      return `${ROUTES.CN03_FORM}/${id}?mode=view`;
    default:
      return null;
  }
}
